<template>
  <div class="component-container">
    <div class="title">扫码登录</div>
    <div class="qr-content">
      <div id="qrCodeUrl" class="image" ref="qrCodeUrl"></div>
      <div v-if="isError" class="qr-error">
        <div class="error-info">正在开发中...</div>
        <!-- <div class="error-info">二维码已失效</div>
        <div class="get-new-qr" @click="onGetQrClick">刷新二维码</div> -->
      </div>
    </div>
    <div class="scan-desc">打开易农无忧APP扫一扫登录</div>
    <div class="bottom-box">
      <div class="bottom-item" @click="onRegiterClick">立即注册</div>
      <div class="bottom-item" @click="onLoginClick">密码登录</div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import { getCreateLoginId, getLoginIdStatus } from "@/api/login";
import { setToken, cookieKeys, setCookieItem } from "@/utils/auth.js";
export default {
  name: "ScanCodeLogin",
  data() {
    return {
      isError: true,
      loginId: "",
      timer: undefined
    };
  },
  mounted() {
    // this._getCreateLoginId();
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    onRegiterClick() {
      this.$emit("onRegiterClick");
    },
    onLoginClick() {
      this.$emit("onLoginClick");
    },
    onGetQrClick() {
      this._getCreateLoginId();
    },
    creatQrCode() {
      this.isError = false;
      document.querySelector("#qrCodeUrl").innerHTML = "";
      new QRCode(this.$refs.qrCodeUrl, {
        text: JSON.stringify({ id: this.loginId, state: 2 }),
        width: 200,
        height: 200,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H
      });
    },
    setPollStatus() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(() => {
        this._getLoginIdStatus();
      }, 1000);
    },
    _getCreateLoginId() {
      getCreateLoginId()
        .then(res => {
          const { data } = res;
          this.loginId = data;
          this.creatQrCode();
          this.setPollStatus();
        })
        .catch(res => {})
        .finally(() => {});
    },
    _getLoginIdStatus() {
      getLoginIdStatus({
        loginId: this.loginId
      })
        .then(res => {
          const { code, data } = res;
          if (code === 1000) {
            if (this.timer) {
              clearInterval(this.timer);
            }
            const { token, phone } = data;
            this.loading = false;
            setToken(token);
            setCookieItem(cookieKeys.phone, phone);
            this.$router.replace("/");
          } else if (code !== 50400) {
            if (this.timer) {
              clearInterval(this.timer);
            }
            this.isError = true;
          }
        })
        .catch(res => {
          this.isError = true;
        })
        .finally(() => {});
    }
  }
};
</script>
<style lang="scss" scoped>
.component-container {
  padding-top: 35px;
  padding-left: 32px;
  text-align: left;
  .title {
    font-size: 24px;
    color: #333333;
    padding-bottom: 20px;
  }
  .qr-content {
    text-align: center;
    margin-top: 50px;
    margin-right: 30px;
    position: relative;
    .image {
      margin: 0 auto;
      width: 200px;
      height: 200px;
    }
    .qr-error {
      position: absolute;
      top: 0;
      left: 50%;
      margin-left: -100px;
      width: 200px;
      height: 200px;
      background: rgba($color: #ffffff, $alpha: 0.94);
      box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.4);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .error-info {
        font-size: 24px;
        color: #333333;
      }
      .get-new-qr {
        margin-top: 19px;
        width: 170px;
        font-size: 18px;
        color: #ffffff;
        cursor: pointer;
        line-height: 50px;
        text-align: center;
        height: 50px;
        background: #1082ff;
      }
    }
  }
  .scan-desc {
    text-align: center;
    font-size: 14px;
    color: #333333;
    margin-top: 10px;
    margin-right: 30px;
  }
  .bottom-box {
    display: flex;
    flex-direction: row-reverse;
    margin-right: 39px;
    margin-top: 54px;
    .bottom-item {
      cursor: pointer;
      font-size: 14px;
      margin-left: 10px;
      margin-right: 10px;
      color: #666666;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/components/scancodelogin.vue